var transform = {
  serializeIn: function serializeIn(settings) {
    var _a;

    var formatValue = settings.formatValue,
        theme = settings.theme;
    var icon = (_a = theme === null || theme === void 0 ? void 0 : theme.metric) === null || _a === void 0 ? void 0 : _a.icon;
    return {
      formatValue: typeof formatValue === 'string' ? formatValue : null,
      iconEnabled: icon === null || icon === void 0 ? void 0 : icon.enabled,
      iconStyle: icon === null || icon === void 0 ? void 0 : icon.style,
      iconType: icon === null || icon === void 0 ? void 0 : icon.type
    };
  },
  serializeOut: function serializeOut(_ref) {
    var formatValue = _ref.formatValue,
        iconEnabled = _ref.iconEnabled,
        iconStyle = _ref.iconStyle,
        iconType = _ref.iconType;
    return {
      formatValue: formatValue,
      theme: {
        metric: {
          icon: {
            enabled: iconEnabled,
            style: iconStyle,
            type: iconType
          }
        }
      }
    };
  }
};
export default transform;